import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/accommodation/actions.js'), 'accommodation/actions.js')
  resolveStoreModules(require('../store/accommodation/getters.js'), 'accommodation/getters.js')
  resolveStoreModules(require('../store/accommodation/mutations.js'), 'accommodation/mutations.js')
  resolveStoreModules(require('../store/accommodation/state.js'), 'accommodation/state.js')
  resolveStoreModules(require('../store/core/actions.ts'), 'core/actions.ts')
  resolveStoreModules(require('../store/core/getters.ts'), 'core/getters.ts')
  resolveStoreModules(require('../store/core/mutations.ts'), 'core/mutations.ts')
  resolveStoreModules(require('../store/core/state.ts'), 'core/state.ts')
  resolveStoreModules(require('../store/electronic/actions.js'), 'electronic/actions.js')
  resolveStoreModules(require('../store/electronic/getters.js'), 'electronic/getters.js')
  resolveStoreModules(require('../store/electronic/mutations.js'), 'electronic/mutations.js')
  resolveStoreModules(require('../store/electronic/state.js'), 'electronic/state.js')
  resolveStoreModules(require('../store/general/actions.js'), 'general/actions.js')
  resolveStoreModules(require('../store/general/getters.js'), 'general/getters.js')
  resolveStoreModules(require('../store/general/mutations.js'), 'general/mutations.js')
  resolveStoreModules(require('../store/general/state.js'), 'general/state.js')
  resolveStoreModules(require('../store/hcp/actions.js'), 'hcp/actions.js')
  resolveStoreModules(require('../store/hcp/getters.js'), 'hcp/getters.js')
  resolveStoreModules(require('../store/hcp/mutations.js'), 'hcp/mutations.js')
  resolveStoreModules(require('../store/hcp/state.js'), 'hcp/state.js')
  resolveStoreModules(require('../store/hcp/transform.js'), 'hcp/transform.js')
  resolveStoreModules(require('../store/health/actions.js'), 'health/actions.js')
  resolveStoreModules(require('../store/health/getters.js'), 'health/getters.js')
  resolveStoreModules(require('../store/health/mutations.js'), 'health/mutations.js')
  resolveStoreModules(require('../store/health/state.js'), 'health/state.js')
  resolveStoreModules(require('../store/health/transform.js'), 'health/transform.js')
  resolveStoreModules(require('../store/lifeInsurance/actions.js'), 'lifeInsurance/actions.js')
  resolveStoreModules(require('../store/lifeInsurance/getters.js'), 'lifeInsurance/getters.js')
  resolveStoreModules(require('../store/lifeInsurance/mutations.js'), 'lifeInsurance/mutations.js')
  resolveStoreModules(require('../store/lifeInsurance/state.js'), 'lifeInsurance/state.js')
  resolveStoreModules(require('../store/lifeInsurance/transform.js'), 'lifeInsurance/transform.js')
  resolveStoreModules(require('../store/policy/actions.js'), 'policy/actions.js')
  resolveStoreModules(require('../store/policy/getters.js'), 'policy/getters.js')
  resolveStoreModules(require('../store/policy/mutations.js'), 'policy/mutations.js')
  resolveStoreModules(require('../store/policy/state.js'), 'policy/state.js')
  resolveStoreModules(require('../store/promo/actions.js'), 'promo/actions.js')
  resolveStoreModules(require('../store/promo/getters.js'), 'promo/getters.js')
  resolveStoreModules(require('../store/promo/mutations.js'), 'promo/mutations.js')
  resolveStoreModules(require('../store/promo/state.js'), 'promo/state.js')
  resolveStoreModules(require('../store/smartphone/actions.js'), 'smartphone/actions.js')
  resolveStoreModules(require('../store/smartphone/getters.js'), 'smartphone/getters.js')
  resolveStoreModules(require('../store/smartphone/mutations.js'), 'smartphone/mutations.js')
  resolveStoreModules(require('../store/smartphone/state.js'), 'smartphone/state.js')
  resolveStoreModules(require('../store/smartphone/transform.js'), 'smartphone/transform.js')
  resolveStoreModules(require('../store/tropical-disease/actions.js'), 'tropical-disease/actions.js')
  resolveStoreModules(require('../store/tropical-disease/getters.js'), 'tropical-disease/getters.js')
  resolveStoreModules(require('../store/tropical-disease/mutations.js'), 'tropical-disease/mutations.js')
  resolveStoreModules(require('../store/tropical-disease/state.js'), 'tropical-disease/state.js')
  resolveStoreModules(require('../store/tropical-disease/transform.js'), 'tropical-disease/transform.js')
  resolveStoreModules(require('../store/user/actions.js'), 'user/actions.js')
  resolveStoreModules(require('../store/user/getters.js'), 'user/getters.js')
  resolveStoreModules(require('../store/user/mutations.js'), 'user/mutations.js')
  resolveStoreModules(require('../store/user/state.js'), 'user/state.js')
  resolveStoreModules(require('../store/vehicle/actions.js'), 'vehicle/actions.js')
  resolveStoreModules(require('../store/vehicle/getters.js'), 'vehicle/getters.js')
  resolveStoreModules(require('../store/vehicle/mutations.js'), 'vehicle/mutations.js')
  resolveStoreModules(require('../store/vehicle/state.js'), 'vehicle/state.js')
  resolveStoreModules(require('../store/vehicle/transform.js'), 'vehicle/transform.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
